import React, {useState, useEffect} from 'react';
//containers
import View from './enter-results-view';
//utils
import {ClubService} from '../../../utils/data-transfer';

const _clubService = new ClubService();

const EnterResultsContainers = (props) => {
  const {details, opponent} = props;
  const [state, setState] = useState({resultsEntry: {
      matchDate: new Date(),
      clubId: '',
      clubName: '',
      winningTeamId: '',
      score: ''
    },
    clubs: []
  });

  useEffect(() => {
    let homeTeam = details.nextOpponent.isHome ? opponent : details;

    setState(prevState => ({
      ...prevState,
      resultsEntry: Object.assign({}, state.resultsEntry, { clubId: homeTeam.clubId, clubName: homeTeam.clubName })
    }));
  }, []);

  const getClubsMatchingQuery = async (queryString) => {
    try {
      let clubs = await _clubService.getAnonymousFilteredClubs(queryString);

      setState(prevState => ({...prevState, clubs}));
    } catch (err) {
      console.log(err);
      //handle this!
    }
  };

  const handleDateChange = (momentDate) =>
    setState(prevState => ({...prevState, resultsEntry: Object.assign({}, state.resultsEntry, {matchDate: momentDate ? momentDate.toDate() : ''})}));

  const handleClubChange = (clubId) =>
    setState(prevState => ({...prevState, resultsEntry: Object.assign({}, state.resultsEntry, {clubId})}));

  const handleResultChange = (e) =>
    setState(prevState => ({...prevState, resultsEntry: Object.assign({}, state.resultsEntry, {[e.target.name]: e.target.value})}));

  return (
    <View
      {...state}
      {...props}
      getClubsMatchingQuery={getClubsMatchingQuery}
      handleDateChange={handleDateChange}
      handleClubChange={handleClubChange}
      handleResultChange={handleResultChange}/>
  );
};

export default EnterResultsContainers;
